'use client';

import { Typography } from '@musinsa/mds';
import { Tooltip } from '@musinsa/mds-ui';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { SETTLEMENT_FORM_SCHEMA } from './settlement-form.schema';

interface SettlementFormHeaderProps {
  title: string;
  className?: string;
  hasTooltip?: boolean;
}

export const SettlementFormHeader = ({
  title,
  className,
  hasTooltip = false,
}: SettlementFormHeaderProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(true);

  useEffect(() => {
    if (hasTooltip) {
      const timer = setTimeout(() => {
        setIsTooltipVisible(false);
      }, SETTLEMENT_FORM_SCHEMA.ui.tooltipDisplayDuration);

      return () => clearTimeout(timer);
    }
  }, [hasTooltip]);

  return (
    <div className={twMerge('flex pb-2', className)}>
      <Typography size="18" weight="medium" className="flex items-center gap-8 relative">
        {title}
        {isTooltipVisible && hasTooltip && (
          <Tooltip
            className="!absolute -right-[130px] -top-[12px]"
            align="right center"
            content={
              <>
                발생한 수익 지급을 위한
                <br />
                정산 정보를 등록해주세요
              </>
            }
            duration={5000}
          />
        )}
      </Typography>
    </div>
  );
};
